/*
 *
 * Users reducer
 * used for app users and org members
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
import { GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, ADD_USERS_SUCCESS, SELECT_USER, ADD_MEMBERS_REQUEST, ADD_MEMBERS_FAILURE, ADD_MEMBERS_SUCCESS, QUERY_USERS, SELECT_ALL_USERS, RESET_PASSWORD_REQUEST, RESET_PASSWORD_FAILURE, RESET_PASSWORD_SUCCESS, DELETE_USER_REQUEST, DELETE_USER_FAILURE, DELETE_USER_SUCCESS, TOGGLE_ALL_USERS, GET_LAST_ADMIN_ORGS_REQUEST, GET_LAST_ADMIN_ORGS_FAILURE, GET_LAST_ADMIN_ORGS_SUCCESS, DELETE_BULK_USERS_SUCCESS, } from './constants';
export var initialState = {
    users: [],
    usersAppId: '',
    meta: {},
    loading: false,
    adding: false,
    deleting: false,
    resettingPassword: false,
    error: '',
    searchQuery: '',
    allUsers: false,
    lastAdminCheckUser: '',
    lastAdminOrgs: {},
    lastAdminOrgsLoading: false,
    lastAdminOrgsError: false,
};
function usersReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case GET_USERS_REQUEST:
                state.loading = true;
                state.error = '';
                break;
            case GET_USERS_FAILURE:
                state.loading = false;
                state.error = 'Something went wrong getting users';
                break;
            case GET_USERS_SUCCESS:
                state.users = action.users;
                state.usersAppId = action.usersAppId;
                state.meta = action.meta;
                state.loading = false;
                state.error = '';
                break;
            case ADD_USERS_SUCCESS:
                state.users = __spreadArray(__spreadArray([], state.users, true), ((action === null || action === void 0 ? void 0 : action.users) || []), true);
                break;
            case QUERY_USERS:
                state.searchQuery = action.searchQuery;
                break;
            case SELECT_USER: {
                var idx = state.users.findIndex(function (u) { return u.id === action.userId; });
                if (idx > -1) {
                    state.users[idx].selected = action.selected;
                }
                break;
            }
            case SELECT_ALL_USERS:
                state.users = state.users.map(function (u) { return (__assign(__assign({}, u), { selected: action.selected })); });
                state.touched = true;
                break;
            case ADD_MEMBERS_REQUEST:
                state.adding = true;
                state.error = '';
                break;
            case ADD_MEMBERS_FAILURE:
                state.adding = false;
                state.error = 'Something went wrong adding members';
                break;
            case ADD_MEMBERS_SUCCESS:
                state.adding = false;
                state.error = '';
                break;
            case RESET_PASSWORD_REQUEST:
                state.resettingPassword = true;
                state.error = '';
                break;
            case RESET_PASSWORD_FAILURE:
                state.resettingPassword = false;
                state.error = 'Something went wrong while resetting the password';
                break;
            case RESET_PASSWORD_SUCCESS:
                state.resettingPassword = false;
                state.error = '';
                break;
            case DELETE_USER_REQUEST:
                state.deleting = true;
                state.error = '';
                break;
            case DELETE_USER_FAILURE:
                state.deleting = false;
                state.error = 'Something went wrong while deleting the user';
                break;
            case DELETE_USER_SUCCESS:
                state.deleting = false;
                state.error = '';
                break;
            case DELETE_BULK_USERS_SUCCESS:
                state.deleting = false;
                state.error = '';
                state.users = state.users.filter(function (u) { return !action.userIdArray.includes(u.id); });
                break;
            case TOGGLE_ALL_USERS:
                state.allUsers = action.allUsers;
                break;
            case GET_LAST_ADMIN_ORGS_REQUEST:
                state.lastAdminOrgsLoading = true;
                state.lastAdminOrgsError = false;
                break;
            case GET_LAST_ADMIN_ORGS_FAILURE:
                state.lastAdminOrgsLoading = false;
                state.lastAdminOrgsError = true;
                break;
            case GET_LAST_ADMIN_ORGS_SUCCESS:
                state.lastAdminOrgsLoading = false;
                state.lastAdminOrgsError = false;
                state.lastAdminCheckUser = action.lastAdminCheckUser;
                state.lastAdminOrgs = action.lastAdminOrgs;
                break;
            default:
                break;
        }
    });
}
export default usersReducer;
